module.exports = __webpack_public_path__ + "img/457.5573c6f1.jpg";